import { render, staticRenderFns } from "./CreateNew.vue?vue&type=template&id=6920557d&"
import script from "./CreateNew.vue?vue&type=script&lang=js&"
export * from "./CreateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports